var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-panel-text"},[_vm._v("整改数量排行")]),_c('dv-scroll-ranking-board',{staticStyle:{"width":"500px","height":"300px"},attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }